import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/home';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link
            to="/"
            className={`flex items-center gap-2 whitespace-nowrap ${
              isScrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
          >
            <span className="font-heading text-xl font-bold tracking-wide">
              黑料吃瓜
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {categories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium whitespace-nowrap hover:opacity-80 transition-opacity ${
                  isScrolled ? 'text-foreground-700' : 'text-background-50/90'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`text-sm font-medium whitespace-nowrap hover:opacity-80 transition-opacity ${
                isScrolled ? 'text-foreground-700' : 'text-background-50/90'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/category/daily-contest"
              className="whitespace-nowrap px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors cursor-pointer"
            >
              立即吃瓜
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <button
            className={`md:hidden w-8 h-8 flex items-center justify-center cursor-pointer ${
              isScrolled ? 'text-foreground-950' : 'text-background-50'
            }`}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-4 flex flex-col gap-3">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className="text-foreground-700 text-sm font-medium py-2 cursor-pointer"
                onClick={() => setMobileMenuOpen(false)}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className="text-foreground-700 text-sm font-medium py-2 cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              关于我们
            </Link>
            <Link
              to="/category/daily-contest"
              className="whitespace-nowrap px-5 py-2 rounded-full bg-primary-500 text-background-50 text-sm font-semibold text-center cursor-pointer"
              onClick={() => setMobileMenuOpen(false)}
            >
              立即吃瓜
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}